import script from "./toggle-switch.vue?vue&type=script&setup=true&lang=js"
export * from "./toggle-switch.vue?vue&type=script&setup=true&lang=js"

import "./toggle-switch.vue?vue&type=style&index=0&id=715b0e02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715b0e02"]])

export default __exports__